import { Link } from 'react-router';

import { site } from '@/content/site';
import { cn } from '@/lib/cn';

import { Symbole } from './Symbole';

type SignatureProps = {
  /** Symbole animé : réservé à l'en-tête. */
  animated?: boolean;
  /** Nom réduit sous 720 px, pour que l'en-tête tienne à 360 px de large. */
  compact?: boolean;
  className?: string;
};

/**
 * Logo composé (maquette, charte § 04) : symbole de 30 px et « AICECAP » en
 * Geist 600, interlettrage +0,05 em, « AI » en Geist 700 et en ciel. Le nom
 * est du texte, jamais une image. La couleur suit le parent : encre sur
 * clair, blanc sur encre.
 */
export function Signature({ animated = false, compact = false, className }: SignatureProps) {
  return (
    <Link
      to="/"
      className={cn('flex items-center no-underline', compact ? 'gap-2 tab:gap-2.5' : 'gap-2.5', className)}
      aria-label={`${site.name}, accueil`}
    >
      <Symbole size={compact ? 26 : 30} animated={animated} className={cn(compact && 'tab:size-[30px]')} />
      <span
        className={cn(
          'leading-none font-semibold tracking-[0.05em]',
          // Sous 384 px, l'en-tête ne garde que le symbole (charte § 04, symbole seul).
          compact ? 'text-h6 max-[24rem]:hidden tab:text-h4' : 'text-h4',
        )}
      >
        <b className="font-bold text-ciel">AI</b>CECAP
      </span>
    </Link>
  );
}
